/**
 * LOGO TAKEOFF — the trigger rule, kept pure so it can be reasoned about and
 * tested on its own, away from the component's store and DOM wiring.
 *
 * A click on the sidebar home mark plays the takeoff ONLY when it actually
 * travels home (you were on another screen), there is no lift already in flight
 * (so a rapid double-click can't stack), and motion is allowed. Otherwise the
 * click just navigates, quietly — which is why idle logo-clicking while already
 * on the Board never tires.
 */
export function shouldLift(view: string, lifting: boolean, reducedMotion: boolean): boolean {
  return view !== 'board' && !lifting && !reducedMotion;
}
